export  function addOrg(value){
    return dispatch => {
        dispatch({
            type: 'ADD',
            payload: value,
        })
    }
}